import React from 'react';
import AuthValidateData from './validateData';

const AuthActionBtn = props => {
  const {
    loading,
    tab,
    getCode,
    phone,
    password,
    errorPhone,
    errorPassword,
    agreementAccepted,
    personalDataAccepted,
  } = props;

  const btnClasses = ['btn', 'btn--accent']; // TODO color btn
  if (loading) btnClasses.push('btn--loading');

  let type = 'submit';

  if (
    !AuthValidateData({
      tab,
      phone,
      password,
      errorPhone,
      errorPassword,
      getCode,
      agreementAccepted,
      personalDataAccepted,
    })
  ) {
    type = 'button';
    btnClasses.push('btn--disable');
  }

  let buttonTxt = '';

  switch (tab) {
    case 'auth':
      buttonTxt = 'Войти';
      if (errorPhone) buttonTxt = 'Зарегистрироваться';
      break;

    case 'reg':
      buttonTxt = 'Зарегистрироваться';
      if (errorPhone) buttonTxt = 'Войти';
      if (getCode) buttonTxt = 'Зарегистрироваться';
      break;

    case 'forget':
      buttonTxt = 'Сбросить пароль';
      if (errorPhone) buttonTxt = 'Зарегистрироваться';
      if (getCode) buttonTxt = 'Войти';
      break;

    default:
      break;
  }
  return (
    <button className={btnClasses.join(' ')} type={type}>
      {buttonTxt}
    </button>
  );
};
export default AuthActionBtn;
